// api/services/taxonomies.ts
import { handleRequest } from '@/api';
import type { Taxonomy } from '@/types';

interface FetchOpts {
    signal?: AbortSignal;
}

export const getTaxonomies = (opts: FetchOpts = {}): Promise<Taxonomy[]> =>
    handleRequest<Taxonomy[]>('get', `/taxonomies/`, opts);
